import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import { getContestInformations, getContestInformationsFinal, getRankingInformations, ipAdress, loginUser } from '../data/getAxiosRequests';
import { useLocation, useNavigate } from 'react-router-dom';
import { csrftoken } from '../constants/helpers';
import IconButton from '../components/UI/IconButton';
import { SVGs } from '../constants/Svgs';

import { RankingLineFinalsProps, RankingLineProps } from '../constants/types';
import RankingTab from '../components/party/RankingTab';
import RankingTabOneChallenge from '../components/party/RankingTabOneChallenge';
import CustomButton from '../components/UI/CustomButton';
import { TailSpin } from 'react-loader-spinner';
import { Colors } from '../constants/Consts';
import RankingTabOneContest from '../components/party/RankingTabOneContest';
import RankingTabOneContestFinals from '../components/party/RankingTabOneContestFinals';

const 
ContestFinalsScreen = () => {

    useEffect(() => {
        document.title = "Hardbloc Games #4"},[])
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token');
    const uid = queryParams.get('uid');
    const navigate = useNavigate()
    
    // States for storing ranking data
    const [rankingVersatile, setRankingVersatile] = useState<RankingLineFinalsProps[]>([]);
    const [rankingStrongest, setRankingStrongest] = useState<RankingLineFinalsProps[]>([]);
    const [rankingPosts, setRankingPosts] = useState<RankingLineFinalsProps[]>([]);
    const [isAutoRefreshed, setIsAutoRefreshed] = useState(true);  // Control auto-refresh
    const [showData, setShowData] = useState(false); 
    const [countSessions, setCountSessions] = useState(0)
    const timeLimit = new Date(2025, 4, 17, 21, 0, 0, 0);  // Note: month is 0-indexed, so 5 is June
    const [currentTime, setCurrentTime] = useState(new Date())


    function getTimeLeft(currentTime: Date): string {
        const diff = timeLimit.getTime() - currentTime.getTime();
    
        if (diff < 0) {
            return "C'est terminé ! Place aux récompenses !!";
        }
    
        // Convert milliseconds to minutes, hours, and days
        const minutesTotal = Math.floor(diff / 60000);
        const hoursTotal = Math.floor(minutesTotal / 60);
        const days = Math.floor(hoursTotal / 24);
        const hours = hoursTotal % 24;
        const minutes = minutesTotal % 60;
    
        // Format the response based on the duration
        if (days > 0) {
            const daysText = days === 1 ? "jour" : "jours";
            const hoursText = hours === 1 ? "heure" : "heures";
            return `${days} ${daysText}, ${hours} ${hoursText} et ${minutes} ${minutes === 1 ? "minute" : "minutes"}`;
        } else if (hours > 0) {
            const hoursText = hours === 1 ? "heure" : "heures";
            const minutesText = minutes === 1 ? "minute" : "minutes";
            return `${hours} ${hoursText} et ${minutes} ${minutesText}`;
        } else {
            if (minutes === 0) {
                return "1 minute";
            } else {
                const minutesText = minutes === 1 ? "minute" : "minutes";
                return `${minutes} ${minutesText}`;
            }
        }
    }
    

    useEffect(() => {
        // Function to update 'now'
        if(currentTime < timeLimit) {
            const updateNow = () => {
                const latestTime = new Date();
                setCurrentTime(latestTime);
            };

        // Set an interval to update 'now' every second
            const intervalId = setInterval(updateNow, 15000);
        

        // Cleanup function to clear interval
            return () => clearInterval(intervalId);
        }
        else{
            setIsAutoRefreshed(false)
        }
    }, [currentTime])

    // Function to fetch all ranking data
    const fetchRankingData = async () => {
        try {
            const data = await getContestInformationsFinal();
            setRankingStrongest(data.strongest)
            setRankingVersatile(data.female)
        } catch (error) {
            console.error('Failed to fetch ranking data:', error);
        }
    };

    useEffect(() => {
        fetchRankingData().then(()=>setShowData(true));  // Initial fetch
    }, []);

    // useEffect to handle data fetching and auto-refresh every 20 seconds
    useEffect(() => {
        if (isAutoRefreshed) {
            fetchRankingData();  // Initial fetch
            const intervalId = setInterval(fetchRankingData, 15000);  // Set up interval

            return () => clearInterval(intervalId);  // Cleanup interval on component unmount
        }
    }, [isAutoRefreshed]);


    return (
        <div className='party_outercontainer_bis'>
            <div className='party_header_bis'>
               
                <div style={{alignItems:'center'}}>
                    <p className='headings-nohemi-2 title_party_header_bis'>Hardbloc games #4</p>
                    <p className='headings-nohemi-4 title_party_header_bis'>1000 points par bloc divisé par le nombre de grimpeurs l'ayant réussi. Amusez-vous !</p>
                </div>
                
            </div>
            <div className='party_ranking_section_bis'>
                <div className='party_ranking_tabs_section_container_bis'>
                    <div className='party_ranking_tabs_section_upper_section_bis'>
                        <CustomButton
                            text=''
                            Svg={SVGs.crown}
                        />
                        <div className='party_ranking_tabs_text regular large2'>
                            <div className='headings-nohemi-4-bold'>Classement Hommes</div>
                            <div className='regular light party_ranking_tabs_subtext'>
                                <div>Valide tes blocs sur Gaston et gagne un maximum de points</div>
                            </div>
                        </div>
                    </div>
                    {showData ?
                    
                        <div className='party_ranking_tabs_section'>
                            <RankingTabOneContestFinals
                                lines={rankingStrongest}
                                shouldShowPoints={true}
                                shouldPointsBeTransformed={false}
                                category='Hommes'
                            />
                           
                        </div>
                        
                   
                        :
                  
                            <div >
                                <TailSpin color={Colors.colorprimary400} height={80} width={80} />
                            </div>
                         
                    }
                </div>
               
                <div className='party_ranking_tabs_section_container_bis'>
                    <div className='party_ranking_tabs_section_upper_section_bis'>
                        <CustomButton
                            text=''
                            Svg={SVGs.crown}
                        />
                        <div className='party_ranking_tabs_text regular large2'>
                            <div className='headings-nohemi-4-bold'>Classement Femmes</div>
                            <div className='regular light party_ranking_tabs_subtext'>
                                <div>Valide tes blocs sur Gaston et gagne un maximum de points</div>
                            </div>
                        </div>
                    </div>
                    {showData ?
                    
                        <div className='party_ranking_tabs_section'>
                            <RankingTabOneContestFinals
                                lines={rankingVersatile}
                                shouldShowPoints={true}
                                shouldPointsBeTransformed={false}
                                category='Bêta'
                            />
                        </div>
                        
                
                        :
                  
                            <div >
                                <TailSpin color={Colors.colorprimary400} height={80} width={80} />
                            </div>
                         
                    }
                </div>
               {/* 
                <div className='party_ranking_tabs_section_container_bis'>
                    <div className='party_ranking_tabs_section_upper_section_bis'>
                        <CustomButton
                            text=''
                            Svg={SVGs.dice}
                        />
                        <div className='party_ranking_tabs_text regular large2'>
                            <div className='headings-nohemi-4-bold'>La séance d'or</div>
                            <div className='regular light party_ranking_tabs_subtext'>
                                <div>Rentre ta séance sur Gaston pour avoir une chance de gagner. On tire une personne au sort !</div>
                            </div>
                        </div>
                    </div>
                    {showData ?
                
                        <div className='party_ranking_tabs_section'>
                            <RankingTabOneChallenge
                                lines={rankingPosts}
                                shouldShowPoints={false}
                                shouldPointsBeTransformed={false}
                                category='Bêta'
                            />
                        </div>
                        
                  
                        :
                  
                            <div >
                                <TailSpin color={Colors.colorprimary400} height={80} width={80} />
                            </div>
                         
                    }
                </div>
                */}
            </div>

            
        </div>
    );
}

export default ContestFinalsScreen;